import { api } from "@/services/api/Api";

const addDefaultHeader = (name, value) => {
  api.defaults.headers[name] = value;
};

export const ApiUtils = {
  addDefaultHeader,
};
